import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative grid" }
const _hoisted_2 = ["value"]

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import Button from "../Button";
import Lucide from "../Lucide";
import jsBeautify from "js-beautify";
import hljs from "highlight.js";
import {
  withDefaults,
  computed,
  HTMLAttributes,
  useAttrs,
  ref,
  onMounted,
} from "vue";

interface HighlightProps extends HTMLAttributes {
  copyButton?: boolean;
  type?: "html" | "javascript";
}


const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Highlight',
  props: {
    copyButton: { type: Boolean, default: true },
    type: { default: "html" }
  },
  setup(__props: any) {

const props = __props as { copyButton: boolean, type: "html" | "javascript" }



const copyText = ref("Copy example code");
const highlightRef = ref<HTMLDivElement>();
const copySourceEl = ref<HTMLTextAreaElement>();
const copySource = ref("");

const attrs = useAttrs();

const buttonComputedClass = computed(() =>
  twMerge(["py-1 px-2", typeof attrs.class === "string" && attrs.class])
);

const highlightComputedClass = computed(() =>
  twMerge([
    "rounded-md overflow-hidden relative",
    props.copyButton && "mt-3",
    !props.copyButton && typeof attrs.class === "string" && attrs.class,
  ])
);

const codePreviewComputedClass = computed(() =>
  twMerge([
    "text-xs leading-relaxed [&.hljs]:bg-slate-50 [&.hljs]:px-5 [&.hljs]:py-4",
    "[&.hljs]:dark:text-slate-200 [&.hljs]:dark:bg-darkmode-700 [&.hljs_.hljs-string]:dark:text-slate-200 [&.hljs_.hljs-tag]:dark:text-slate-200 [&.hljs_.hljs-name]:dark:text-emerald-500 [&.hljs_.hljs-attr]:dark:text-sky-500",
    "before:content-['HTML'] before:font-roboto before:font-medium before:px-4 before:py-2 before:block before:absolute before:top-0 before:right-0 before:rounded-bl before:bg-slate-200 before:bg-opacity-70 before:dark:bg-darkmode-400",
    "[&.javascript]:before:content-['JS']",
    props.type,
  ])
);

const copyCode = () => {
  copyText.value = "Copied!";
  setTimeout(() => {
    copyText.value = "Copy example code";
  }, 1500);

  copySourceEl.value?.select();
  copySourceEl.value?.setSelectionRange(0, 99999);
  document.execCommand("copy");
};

onMounted(() => {
  if (highlightRef.value) {
    const codeEl = highlightRef.value.querySelectorAll("code")[0];
    let source = codeEl.innerHTML;

    // Format for beautify
    source = _.replace(source, /&lt;/g, "<");
    source = _.replace(source, /&gt;/g, ">");

    // Beautify code
    source = jsBeautify.html(source);

    // Save for copy code function
    copySource.value = source;

    // Format for highlight.js
    source = _.replace(source, /</g, "&lt;");
    source = _.replace(source, />/g, "&gt;");

    codeEl.innerHTML = source;

    hljs.highlightElement(codeEl);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (props.copyButton)
      ? (_openBlock(), _createBlock(_unref(Button), _mergeProps({
          key: 0,
          variant: "outline-secondary",
          class: _unref(buttonComputedClass)
        }, _unref(_).omit(_unref(attrs), 'class'), {
          onClick: _cache[0] || (_cache[0] = 
        () => {
          copyCode();
        }
      )
        }), {
          default: _withCtx(() => [
            _createVNode(_unref(Lucide), {
              icon: "File",
              class: "w-4 h-4 mr-2"
            }),
            _createTextVNode(" " + _toDisplayString(copyText.value), 1)
          ]),
          _: 1
        }, 16, ["class"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "highlightRef",
      ref: highlightRef,
      class: _normalizeClass(_unref(highlightComputedClass))
    }, [
      _createElementVNode("pre", _hoisted_1, [
        _createTextVNode("        "),
        _createElementVNode("code", {
          class: _normalizeClass(_unref(codePreviewComputedClass))
        }, [
          _createTextVNode("\n          "),
          _renderSlot(_ctx.$slots, "default"),
          _createTextVNode("\n        ")
        ], 2),
        _createTextVNode("\n        "),
        _createElementVNode("textarea", {
          ref_key: "copySourceEl",
          ref: copySourceEl,
          value: copySource.value,
          class: "absolute w-0 h-0 p-0 -mt-1 -ml-1"
        }, null, 8, _hoisted_2),
        _createTextVNode("\n      ")
      ])
    ], 2)
  ]))
}
}

})